module.exports = __webpack_public_path__ + "static/media/DropdownArrow.2551c158.svg";